<template>
  <div>
    <!-- Carousel display if small screen and up -->
    <div v-if="$vuetify.breakpoint.smAndUp">
      <!-- Pet boarding -->
      <v-carousel continuous cycle hide-delimiter-background height="auto">
        <v-carousel-item src="@/assets/images/carousel/love-paws-homestay-pet-boarding-bg.jpg">
          <v-row class="fill-height" align="center" justify="center">
            <div class="carousel-text carousel-text-right white--text">
              <h3 class="primary--text">Pet Boarding</h3>
              <p>Our home pet boarding services at Love Paws offers individual attention, regular walks at our very own 6,000 sqft home, beautiful garden to walk on and other opportunity to socialise with other pets in the household.</p>
              <p>
                Below 10 kg = RM40 / night
                <br />Above 10 kg = RM 60 / night
                <br />Above 20 kg = RM 70 / night
              </p>

              <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
            </div>
          </v-row>
        </v-carousel-item>

        <!-- Pet grooming -->
        <v-carousel-item src="@/assets/images/carousel/love-paws-homestay-pet-grooming-bg.jpg">
          <v-row class="fill-height" align="center" justify="center">
            <div class="carousel-text carousel-text-left">
              <h3 class="primary--text">Pet Grooming</h3>
              <p>
                We offer basic grooming &#x26; full grooming services.
                <br />We use only good quality products that are gentle to skin.
                <br />Your pets will get a free massage session while bathing to keep them calm during grooming session.
                <br />
                <br />All grooming charges will be separated from boarding charges.
                Grooming charges are based on pet's condition.
              </p>
              <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
            </div>
          </v-row>
        </v-carousel-item>

        <!-- Pet daycare -->
        <v-carousel-item src="@/assets/images/carousel/love-paws-homestay-pet-daycare-bg.jpg">
          <v-row class="fill-height" align="center" justify="center">
            <div class="carousel-text carousel-text-right">
              <h3 class="primary--text">Pet Daycare</h3>
              <p>Long hours at the office while your pet sits at home waiting? Let them have some fun at our fun-filled day care at Love Paws Homestay. We provide 6 hours & 12 hours day care services at our homestay.</p>
              <p>
                6 hours = RM 20
                <br />12 hours = RM 30
              </p>
              <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
            </div>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </div>

    <!-- If small screens -->
    <div v-else>
      <!-- Small screen pet boarding -->
      <div class="card-padding">
        <v-card class="mx-auto">
          <v-img src="@/assets/images/carousel/love-paws-homestay-pet-boarding-bg.jpg">
            <v-card-title class="align-end fill-height justify-end">
              <h3>Pet Boarding</h3>
            </v-card-title>
          </v-img>

          <v-card-text>
            <p>Our home pet boarding services at Love Paws offers individual attention, regular walks at our very own 6,000 sqft home, beautiful garden to walk on and other opportunity to socialise with other pets in the household.</p>
            <p>
              Below 10 kg = RM40 / night
              <br />Above 10 kg = RM 60 / night
              <br />Above 20 kg = RM 70 / night
            </p>
          </v-card-text>

          <v-card-actions>
            <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <!-- Small screen pet grooming -->
      <div class="card-padding">
        <v-card class="mx-auto">
          <v-img src="@/assets/images/carousel/love-paws-homestay-pet-grooming-bg.jpg">
            <v-card-title class="align-end fill-height font">
              <h3>Pet Grooming</h3>
            </v-card-title>
          </v-img>

          <v-card-text>
            <p>
              We offer basic grooming &#x26; full grooming services.
              <br />We use only good quality products that are gentle to skin.
              <br />Your pets will get a free massage session while bathing to keep them calm during grooming session.
              <br />
              <br />All grooming charges will be separated from boarding charges.
              Grooming charges are based on pet's condition.
            </p>
          </v-card-text>

          <v-card-actions>
            <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <!-- Small screen pet daycare -->
      <div class="card-padding">
        <v-card class="mx-auto">
          <v-img src="@/assets/images/carousel/love-paws-homestay-pet-daycare-bg.jpg">
            <v-card-title class="align-end fill-height justify-end">
              <h3>Pet Daycare</h3>
            </v-card-title>
          </v-img>

          <v-card-text>
            <p>Long hours at the office while your pet sits at home waiting? Let them have some fun at our fun-filled day care at Love Paws Homestay. We provide 6 hours & 12 hours day care services at our homestay.</p>
            <p>
              6 hours = RM 20
              <br />12 hours = RM 30
            </p>
          </v-card-text>

          <v-card-actions>
            <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    makeABooking: function() {
      const bookingDate = new Date().toISOString().substr(0, 10);
      this.$emit("book", bookingDate);
    }
  }
};
</script>

<style scoped>
.carousel-text-left {
  max-width: 50%;
  margin-left: 50%;
  margin-right: 10%;
}
.carousel-text-right {
  max-width: 50%;
  margin-right: 50%;
  margin-left: 10%;
}
.carousel-text p {
  font-size: 1.3rem;
}
.carousel-text h3 {
  /* font-size: 6vh; */
  /* font-size: 3em; */
  font-size: 2rem;
}
.card-padding {
  padding: 12px;
}
</style>